import {defineMessages} from 'react-intl';

// Countries and languages from SFCC should be synchronized
export default defineMessages({
	AF: {
		id: 'country.AF',
		defaultMessage: 'Afghanistan'
	},
	AX: {
		id: 'country.AX',
		defaultMessage: 'Aland Islands'
	},
	AL: {
		id: 'country.AL',
		defaultMessage: 'Albania'
	},
	DZ: {
		id: 'country.DZ',
		defaultMessage: 'Algeria'
	},
	AS: {
		id: 'country.AS',
		defaultMessage: 'American Samoa'
	},
	AD: {
		id: 'country.AD',
		defaultMessage: 'Andorra'
	},
	AO: {
		id: 'country.AO',
		defaultMessage: 'Angola'
	},
	AI: {
		id: 'country.AI',
		defaultMessage: 'Anguilla'
	},
	AQ: {
		id: 'country.AQ',
		defaultMessage: 'Antarctica'
	},
	AG: {
		id: 'country.AG',
		defaultMessage: 'Antigua and Barbuda'
	},
	AR: {
		id: 'country.AR',
		defaultMessage: 'Argentina'
	},
	AM: {
		id: 'country.AM',
		defaultMessage: 'Armenia'
	},
	AW: {
		id: 'country.AW',
		defaultMessage: 'Aruba'
	},
	AU: {
		id: 'country.AU',
		defaultMessage: 'Australia'
	},
	AT: {
		id: 'country.AT',
		defaultMessage: 'Austria'
	},
	AZ: {
		id: 'country.AZ',
		defaultMessage: 'Azerbaijan'
	},
	BS: {
		id: 'country.BS',
		defaultMessage: 'Bahamas'
	},
	BH: {
		id: 'country.BH',
		defaultMessage: 'Bahrain'
	},
	BD: {
		id: 'country.BD',
		defaultMessage: 'Bangladesh'
	},
	BB: {
		id: 'country.BB',
		defaultMessage: 'Barbados'
	},
	BY: {
		id: 'country.BY',
		defaultMessage: 'Belarus'
	},
	BE: {
		id: 'country.BE',
		defaultMessage: 'Belgium'
	},
	BZ: {
		id: 'country.BZ',
		defaultMessage: 'Belize'
	},
	BJ: {
		id: 'country.BJ',
		defaultMessage: 'Benin'
	},
	BM: {
		id: 'country.BM',
		defaultMessage: 'Bermuda'
	},
	BT: {
		id: 'country.BT',
		defaultMessage: 'Bhutan'
	},
	BO: {
		id: 'country.BO',
		defaultMessage: 'Bolivia'
	},
	BQ: {
		id: 'country.BQ',
		defaultMessage: 'Bonaire, Saint Eustatius and Saba'
	},
	BA: {
		id: 'country.BA',
		defaultMessage: 'Bosnia and Herzegovina'
	},
	BW: {
		id: 'country.BW',
		defaultMessage: 'Botswana'
	},
	BV: {
		id: 'country.BV',
		defaultMessage: 'Bouvet Island'
	},
	BR: {
		id: 'country.BR',
		defaultMessage: 'Brazil'
	},
	IO: {
		id: 'country.IO',
		defaultMessage: 'British Indian Ocean Territory'
	},
	BN: {
		id: 'country.BN',
		defaultMessage: 'Brunei Darussalam'
	},
	BG: {
		id: 'country.BG',
		defaultMessage: 'Bulgaria'
	},
	BF: {
		id: 'country.BF',
		defaultMessage: 'Burkina Faso'
	},
	BI: {
		id: 'country.BI',
		defaultMessage: 'Burundi'
	},
	KH: {
		id: 'country.KH',
		defaultMessage: 'Cambodia'
	},
	CM: {
		id: 'country.CM',
		defaultMessage: 'Cameroon'
	},
	CA: {
		id: 'country.CA',
		defaultMessage: 'Canada'
	},
	CV: {
		id: 'country.CV',
		defaultMessage: 'Cape Verde'
	},
	KY: {
		id: 'country.KY',
		defaultMessage: 'Cayman Islands'
	},
	CF: {
		id: 'country.CF',
		defaultMessage: 'Central African Republic'
	},
	TD: {
		id: 'country.TD',
		defaultMessage: 'Chad'
	},
	CL: {
		id: 'country.CL',
		defaultMessage: 'Chile'
	},
	CN: {
		id: 'country.CN',
		defaultMessage: 'China, Mainland'
	},
	CX: {
		id: 'country.CX',
		defaultMessage: 'Christmas Island'
	},
	CC: {
		id: 'country.CC',
		defaultMessage: 'Cocos Islands'
	},
	CO: {
		id: 'country.CO',
		defaultMessage: 'Colombia'
	},
	KM: {
		id: 'country.KM',
		defaultMessage: 'Comoros'
	},
	CG: {
		id: 'country.CG',
		defaultMessage: 'Congo'
	},
	CD: {
		id: 'country.CD',
		defaultMessage: 'Democratic Republic of the Congo'
	},
	CK: {
		id: 'country.CK',
		defaultMessage: 'Cook Islands'
	},
	CR: {
		id: 'country.CR',
		defaultMessage: 'Costa Rica'
	},
	CI: {
		id: 'country.CI',
		defaultMessage: "Cote d'Ivoire"
	},
	HR: {
		id: 'country.HR',
		defaultMessage: 'Croatia'
	},
	CU: {
		id: 'country.CU',
		defaultMessage: 'Cuba'
	},
	CW: {
		id: 'country.CW',
		defaultMessage: 'Curacao'
	},
	CY: {
		id: 'country.CY',
		defaultMessage: 'Cyprus'
	},
	CZ: {
		id: 'country.CZ',
		defaultMessage: 'Czech Republic'
	},
	DK: {
		id: 'country.DK',
		defaultMessage: 'Denmark'
	},
	DJ: {
		id: 'country.DJ',
		defaultMessage: 'Djibouti'
	},
	DM: {
		id: 'country.DM',
		defaultMessage: 'Dominica'
	},
	DO: {
		id: 'country.DO',
		defaultMessage: 'Dominican Republic'
	},
	EC: {
		id: 'country.EC',
		defaultMessage: 'Ecuador'
	},
	EG: {
		id: 'country.EG',
		defaultMessage: 'Egypt'
	},
	SV: {
		id: 'country.SV',
		defaultMessage: 'El Salvador'
	},
	GQ: {
		id: 'country.GQ',
		defaultMessage: 'Equatorial Guinea'
	},
	ER: {
		id: 'country.ER',
		defaultMessage: 'Eritrea'
	},
	EE: {
		id: 'country.EE',
		defaultMessage: 'Estonia'
	},
	ET: {
		id: 'country.ET',
		defaultMessage: 'Ethiopia'
	},
	FK: {
		id: 'country.FK',
		defaultMessage: 'Falkland Islands'
	},
	FO: {
		id: 'country.FO',
		defaultMessage: 'Faroe Islands'
	},
	FJ: {
		id: 'country.FJ',
		defaultMessage: 'Fiji'
	},
	FI: {
		id: 'country.FI',
		defaultMessage: 'Finland'
	},
	FR: {
		id: 'country.FR',
		defaultMessage: 'France'
	},
	GF: {
		id: 'country.GF',
		defaultMessage: 'French Guiana'
	},
	PF: {
		id: 'country.PF',
		defaultMessage: 'French Polynesia'
	},
	TF: {
		id: 'country.TF',
		defaultMessage: 'French Southern Territories'
	},
	GA: {
		id: 'country.GA',
		defaultMessage: 'Gabon'
	},
	GM: {
		id: 'country.GM',
		defaultMessage: 'Gambia'
	},
	GE: {
		id: 'country.GE',
		defaultMessage: 'Georgia'
	},
	DE: {
		id: 'country.DE',
		defaultMessage: 'Germany'
	},
	GH: {
		id: 'country.GH',
		defaultMessage: 'Ghana'
	},
	GI: {
		id: 'country.GI',
		defaultMessage: 'Gibraltar'
	},
	GR: {
		id: 'country.GR',
		defaultMessage: 'Greece'
	},
	GL: {
		id: 'country.GL',
		defaultMessage: 'Greenland'
	},
	GD: {
		id: 'country.GD',
		defaultMessage: 'Grenada'
	},
	GP: {
		id: 'country.GP',
		defaultMessage: 'Guadeloupe'
	},
	GU: {
		id: 'country.GU',
		defaultMessage: 'Guam'
	},
	GT: {
		id: 'country.GT',
		defaultMessage: 'Guatemala'
	},
	GG: {
		id: 'country.GG',
		defaultMessage: 'Guernsey'
	},
	GN: {
		id: 'country.GN',
		defaultMessage: 'Guinea'
	},
	GW: {
		id: 'country.GW',
		defaultMessage: 'Guinea-Bissau'
	},
	GY: {
		id: 'country.GY',
		defaultMessage: 'Guyana'
	},
	HT: {
		id: 'country.HT',
		defaultMessage: 'Haiti'
	},
	HM: {
		id: 'country.HM',
		defaultMessage: 'Heard Island and Mcdonald Islands'
	},
	VA: {
		id: 'country.VA',
		defaultMessage: 'Vatican'
	},
	HN: {
		id: 'country.HN',
		defaultMessage: 'Honduras'
	},
	HK: {
		id: 'country.HK',
		defaultMessage: 'Hong Kong, SAR of China'
	},
	HU: {
		id: 'country.HU',
		defaultMessage: 'Hungary'
	},
	IC: {
		id: 'country.IC',
		defaultMessage: 'Canary Islands'
	},
	IS: {
		id: 'country.IS',
		defaultMessage: 'Iceland'
	},
	IN: {
		id: 'country.IN',
		defaultMessage: 'India'
	},
	ID: {
		id: 'country.ID',
		defaultMessage: 'Indonesia'
	},
	IR: {
		id: 'country.IR',
		defaultMessage: 'Iran'
	},
	IQ: {
		id: 'country.IQ',
		defaultMessage: 'Iraq'
	},
	IE: {
		id: 'country.IE',
		defaultMessage: 'Ireland'
	},
	IM: {
		id: 'country.IM',
		defaultMessage: 'Isle of Man'
	},
	IL: {
		id: 'country.IL',
		defaultMessage: 'Israel'
	},
	IT: {
		id: 'country.IT',
		defaultMessage: 'Italy'
	},
	JM: {
		id: 'country.JM',
		defaultMessage: 'Jamaica'
	},
	JP: {
		id: 'country.JP',
		defaultMessage: 'Japan'
	},
	JE: {
		id: 'country.JE',
		defaultMessage: 'Jersey'
	},
	JO: {
		id: 'country.JO',
		defaultMessage: 'Jordan'
	},
	KZ: {
		id: 'country.KZ',
		defaultMessage: 'Kazakhstan'
	},
	KE: {
		id: 'country.KE',
		defaultMessage: 'Kenya'
	},
	KI: {
		id: 'country.KI',
		defaultMessage: 'Kiribati'
	},
	KP: {
		id: 'country.KP',
		defaultMessage: 'North Korea'
	},
	KR: {
		id: 'country.KR',
		defaultMessage: 'South Korea'
	},
	XK: {
		id: 'country.XK',
		defaultMessage: 'Kosovo'
	},
	KW: {
		id: 'country.KW',
		defaultMessage: 'Kuwait'
	},
	KG: {
		id: 'country.KG',
		defaultMessage: 'Kyrgyzstan'
	},
	LA: {
		id: 'country.LA',
		defaultMessage: 'Laos'
	},
	LV: {
		id: 'country.LV',
		defaultMessage: 'Latvia'
	},
	LB: {
		id: 'country.LB',
		defaultMessage: 'Lebanon'
	},
	LS: {
		id: 'country.LS',
		defaultMessage: 'Lesotho'
	},
	LR: {
		id: 'country.LR',
		defaultMessage: 'Liberia'
	},
	LY: {
		id: 'country.LY',
		defaultMessage: 'Libya'
	},
	LI: {
		id: 'country.LI',
		defaultMessage: 'Liechtenstein'
	},
	LT: {
		id: 'country.LT',
		defaultMessage: 'Lithuania'
	},
	LU: {
		id: 'country.LU',
		defaultMessage: 'Luxembourg'
	},
	MO: {
		id: 'country.MO',
		defaultMessage: 'Macao, SAR of China'
	},
	MK: {
		id: 'country.MK',
		defaultMessage: 'Macedonia'
	},
	MG: {
		id: 'country.MG',
		defaultMessage: 'Madagascar'
	},
	MW: {
		id: 'country.MW',
		defaultMessage: 'Malawi'
	},
	MY: {
		id: 'country.MY',
		defaultMessage: 'Malaysia'
	},
	MV: {
		id: 'country.MV',
		defaultMessage: 'Maldives'
	},
	ML: {
		id: 'country.ML',
		defaultMessage: 'Mali'
	},
	MT: {
		id: 'country.MT',
		defaultMessage: 'Malta'
	},
	MH: {
		id: 'country.MH',
		defaultMessage: 'Marshall Islands'
	},
	MQ: {
		id: 'country.MQ',
		defaultMessage: 'Martinique'
	},
	MR: {
		id: 'country.MR',
		defaultMessage: 'Mauritania'
	},
	MU: {
		id: 'country.MU',
		defaultMessage: 'Mauritius'
	},
	YT: {
		id: 'country.YT',
		defaultMessage: 'Mayotte'
	},
	MX: {
		id: 'country.MX',
		defaultMessage: 'Mexico'
	},
	FM: {
		id: 'country.FM',
		defaultMessage: 'Federal States of Micronesia'
	},
	MD: {
		id: 'country.MD',
		defaultMessage: 'Republic of Moldova'
	},
	ME: {
		id: 'country.ME',
		defaultMessage: 'Montenegro'
	},
	MC: {
		id: 'country.MC',
		defaultMessage: 'Monaco'
	},
	MN: {
		id: 'country.MN',
		defaultMessage: 'Mongolia'
	},
	MS: {
		id: 'country.MS',
		defaultMessage: 'Montserrat'
	},
	MA: {
		id: 'country.MA',
		defaultMessage: 'Morocco'
	},
	MZ: {
		id: 'country.MZ',
		defaultMessage: 'Mozambique'
	},
	MM: {
		id: 'country.MM',
		defaultMessage: 'Myanmar'
	},
	NA: {
		id: 'country.NA',
		defaultMessage: 'Namibia'
	},
	NR: {
		id: 'country.NR',
		defaultMessage: 'Nauru'
	},
	NP: {
		id: 'country.NP',
		defaultMessage: 'Nepal'
	},
	NL: {
		id: 'country.NL',
		defaultMessage: 'Netherlands'
	},
	NC: {
		id: 'country.NC',
		defaultMessage: 'New Caledonia'
	},
	NZ: {
		id: 'country.NZ',
		defaultMessage: 'New Zealand'
	},
	NI: {
		id: 'country.NI',
		defaultMessage: 'Nicaragua'
	},
	NE: {
		id: 'country.NE',
		defaultMessage: 'Niger'
	},
	NG: {
		id: 'country.NG',
		defaultMessage: 'Nigeria'
	},
	NU: {
		id: 'country.NU',
		defaultMessage: 'Niue'
	},
	NF: {
		id: 'country.NF',
		defaultMessage: 'Norfolk Island'
	},
	MP: {
		id: 'country.MP',
		defaultMessage: 'Northern Mariana Islands'
	},
	NO: {
		id: 'country.NO',
		defaultMessage: 'Norway'
	},
	OM: {
		id: 'country.OM',
		defaultMessage: 'Oman'
	},
	PK: {
		id: 'country.PK',
		defaultMessage: 'Pakistan'
	},
	PW: {
		id: 'country.PW',
		defaultMessage: 'Palau'
	},
	PS: {
		id: 'country.PS',
		defaultMessage: 'Palestinian National Authority'
	},
	PA: {
		id: 'country.PA',
		defaultMessage: 'Panama'
	},
	PG: {
		id: 'country.PG',
		defaultMessage: 'Papua New Guinea'
	},
	PY: {
		id: 'country.PY',
		defaultMessage: 'Paraguay'
	},
	PE: {
		id: 'country.PE',
		defaultMessage: 'Peru'
	},
	PH: {
		id: 'country.PH',
		defaultMessage: 'Philippines'
	},
	PN: {
		id: 'country.PN',
		defaultMessage: 'Pitcairn Island'
	},
	PL: {
		id: 'country.PL',
		defaultMessage: 'Poland'
	},
	PT: {
		id: 'country.PT',
		defaultMessage: 'Portugal'
	},
	PR: {
		id: 'country.PR',
		defaultMessage: 'Puerto Rico'
	},
	QA: {
		id: 'country.QA',
		defaultMessage: 'Qatar'
	},
	RE: {
		id: 'country.RE',
		defaultMessage: 'Reunion Island'
	},
	RO: {
		id: 'country.RO',
		defaultMessage: 'Romania'
	},
	RS: {
		id: 'country.RS',
		defaultMessage: 'Serbia'
	},
	RU: {
		id: 'country.RU',
		defaultMessage: 'Russian Federation'
	},
	RW: {
		id: 'country.RW',
		defaultMessage: 'Rwanda'
	},
	BL: {
		id: 'country.BL',
		defaultMessage: 'Saint Barthelemy'
	},
	SH: {
		id: 'country.SH',
		defaultMessage: 'Saint Helena'
	},
	KN: {
		id: 'country.KN',
		defaultMessage: 'Saint Kitts and Nevis'
	},
	LC: {
		id: 'country.LC',
		defaultMessage: 'Saint Lucia'
	},
	MF: {
		id: 'country.MF',
		defaultMessage: 'Saint Martin (French part)'
	},
	PM: {
		id: 'country.PM',
		defaultMessage: 'Saint Pierre and Miquelon'
	},
	VC: {
		id: 'country.VC',
		defaultMessage: 'Saint Vincent and the Grenadines'
	},
	WS: {
		id: 'country.WS',
		defaultMessage: 'Samoa'
	},
	SM: {
		id: 'country.SM',
		defaultMessage: 'San Marino'
	},
	ST: {
		id: 'country.ST',
		defaultMessage: 'Sao Tome And Principe'
	},
	SA: {
		id: 'country.SA',
		defaultMessage: 'Saudi Arabia'
	},
	SN: {
		id: 'country.SN',
		defaultMessage: 'Senegal'
	},
	SC: {
		id: 'country.SC',
		defaultMessage: 'Seychelles'
	},
	SL: {
		id: 'country.SL',
		defaultMessage: 'Sierra Leone'
	},
	SG: {
		id: 'country.SG',
		defaultMessage: 'Singapore'
	},
	SX: {
		id: 'country.SX',
		defaultMessage: 'Sint Maarten'
	},
	SK: {
		id: 'country.SK',
		defaultMessage: 'Slovakia'
	},
	SI: {
		id: 'country.SI',
		defaultMessage: 'Slovenia'
	},
	SB: {
		id: 'country.SB',
		defaultMessage: 'Solomon Islands'
	},
	SO: {
		id: 'country.SO',
		defaultMessage: 'Somalia'
	},
	ZA: {
		id: 'country.ZA',
		defaultMessage: 'South Africa'
	},
	GS: {
		id: 'country.GS',
		defaultMessage: 'South Georgia and South Sandwich Islands'
	},
	ES: {
		id: 'country.ES',
		defaultMessage: 'Spain'
	},
	LK: {
		id: 'country.LK',
		defaultMessage: 'Sri Lanka'
	},
	SD: {
		id: 'country.SD',
		defaultMessage: 'Sudan'
	},
	SR: {
		id: 'country.SR',
		defaultMessage: 'Suriname'
	},
	SJ: {
		id: 'country.SJ',
		defaultMessage: 'Svalbard and Jan Mayen Islands'
	},
	SZ: {
		id: 'country.SZ',
		defaultMessage: 'Swaziland'
	},
	SE: {
		id: 'country.SE',
		defaultMessage: 'Sweden'
	},
	CH: {
		id: 'country.CH',
		defaultMessage: 'Switzerland'
	},
	SY: {
		id: 'country.SY',
		defaultMessage: 'Syrian Arab Republic'
	},
	TW: {
		id: 'country.TW',
		defaultMessage: 'Taiwan, China'
	},
	TJ: {
		id: 'country.TJ',
		defaultMessage: 'Tajikistan'
	},
	TZ: {
		id: 'country.TZ',
		defaultMessage: 'Tanzania'
	},
	TH: {
		id: 'country.TH',
		defaultMessage: 'Thailand'
	},
	TL: {
		id: 'country.TL',
		defaultMessage: 'Timor-Leste'
	},
	TG: {
		id: 'country.TG',
		defaultMessage: 'Togo'
	},
	TK: {
		id: 'country.TK',
		defaultMessage: 'Tokelau'
	},
	TO: {
		id: 'country.TO',
		defaultMessage: 'Tonga'
	},
	TT: {
		id: 'country.TT',
		defaultMessage: 'Trinidad And Tobago'
	},
	TN: {
		id: 'country.TN',
		defaultMessage: 'Tunisia'
	},
	TR: {
		id: 'country.TR',
		defaultMessage: 'Turkey'
	},
	TM: {
		id: 'country.TM',
		defaultMessage: 'Turkmenistan'
	},
	TC: {
		id: 'country.TC',
		defaultMessage: 'Turks and Caicos Islands'
	},
	TV: {
		id: 'country.TV',
		defaultMessage: 'Tuvalu'
	},
	UG: {
		id: 'country.UG',
		defaultMessage: 'Uganda'
	},
	UA: {
		id: 'country.UA',
		defaultMessage: 'Ukraine'
	},
	AE: {
		id: 'country.AE',
		defaultMessage: 'United Arab Emirates'
	},
	GB: {
		id: 'country.GB',
		defaultMessage: 'United Kingdom'
	},
	US: {
		id: 'country.US',
		defaultMessage: 'USA'
	},
	UM: {
		id: 'country.UM',
		defaultMessage: 'United States Minor outlying Islands'
	},
	UY: {
		id: 'country.UY',
		defaultMessage: 'Uruguay'
	},
	UZ: {
		id: 'country.UZ',
		defaultMessage: 'Uzbekistan'
	},
	VU: {
		id: 'country.VU',
		defaultMessage: 'Vanuatu'
	},
	VE: {
		id: 'country.VE',
		defaultMessage: 'Venezuela'
	},
	VN: {
		id: 'country.VN',
		defaultMessage: 'Vietnam'
	},
	VG: {
		id: 'country.VG',
		defaultMessage: 'Virgin Islands, British'
	},
	VI: {
		id: 'country.VI',
		defaultMessage: 'Virgin Islands, U.S.'
	},
	WF: {
		id: 'country.WF',
		defaultMessage: 'Wallis And Futuna'
	},
	EH: {
		id: 'country.EH',
		defaultMessage: 'Western Sahara'
	},
	YE: {
		id: 'country.YE',
		defaultMessage: 'Yemen'
	},
	ZM: {
		id: 'country.ZM',
		defaultMessage: 'Zambia'
	},
	ZW: {
		id: 'country.ZW',
		defaultMessage: 'Zimbabwe'
	},
	de: {
		id: 'locale.de',
		defaultMessage: 'Deutsch'
	},
	en: {
		id: 'locale.en',
		defaultMessage: 'English'
	},
	es: {
		id: 'locale.es',
		defaultMessage: 'Español'
	},
	fr: {
		id: 'locale.fr',
		defaultMessage: 'Français'
	},
	it: {
		id: 'locale.it',
		defaultMessage: 'Italiano'
	},
	ja: {
		id: 'locale.ja',
		defaultMessage: '日本語'
	},
	ko: {
		id: 'locale.ko',
		defaultMessage: '한국어'
	},
	pt: {
		id: 'locale.pt',
		defaultMessage: 'Português'
	},
	zh: {
		id: 'locale.zh',
		defaultMessage: '简体中文'
	},
	ar: {
		id: 'locale.ar',
		defaultMessage: 'عربي',
	},
	ru: {
		id: 'locale.ru',
		defaultMessage: 'Русский',
	},
});
